import { render } from "./SettingsPageSidebarFolder.vue?vue&type=template&id=3cd4bb24&scoped=true"
import script from "./SettingsPageSidebarFolder.vue?vue&type=script&lang=js"
export * from "./SettingsPageSidebarFolder.vue?vue&type=script&lang=js"

import "./SettingsPageSidebarFolder.vue?vue&type=style&index=0&id=3cd4bb24&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3cd4bb24"

export default script